import React, { useEffect } from 'react'
import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from "@components"
import { useCustomMappingTable } from "Pages/User/CustomMapping/Table/@hooks"
import { MAPPING_TYPE } from "Pages/User/CustomMapping/@constants"

import { BACKEND_APIS } from "@constants"
import { getExcel } from "@ui-seeker/utils"
import { isTourDemoActive } from "@signals/app"
import {
	acrissColumn,
	actionsColumn,
	airConditionColumn,
	carModelColumn,
	categoriesColumn,
	countriesColumn,
	doorsColumn,
	officesColumn,
	ownerColumn,
	providersColumn,
	seatsColumn,
	sitesColumn,
	transmissionColumn
} from "Pages/User/CustomMapping/Table/columns"
import CustomMappingToolbarSelect from "Pages/User/CustomMapping/Table/CustomToolbarSelect"
import CustomMappingActions from 'Pages/User/CustomMapping/Actions'
import BulkFieldModal from "Pages/User/CustomMapping/Table/BulkFieldModal"


export default function CustomMappingTable({ path }) {
	const { getTableData, isTableLoading, tableData } = useCustomMappingTable(path)

	useEffect(() => {
		getTableData()
	}, [])


	if (isTableLoading) return <AppResultsSkeleton rows={13} columns={6}/>
	if (isTourDemoActive.value && !tableData?.length) return null

	return <>
		<BulkFieldModal path={path}/>
		<AppCrudTable
		title={<AppCardTitle icon="shuffle" title={path === MAPPING_TYPE.ACRISS ? "Custom ACRISS Mapping List" : "Custom Categories Mapping List"}/>}
		options={{
			customToolbar: () => <CustomMappingActions path={path}/>,
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <CustomMappingToolbarSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}
				path={path}
			/>,
			onDownload: () => getExcel(`${path === MAPPING_TYPE.ACRISS ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY}/list/excel`, {}),
		}}
		columns={[
			...officesColumn(),
			...countriesColumn(),
			...sitesColumn(),
			path === MAPPING_TYPE.ACRISS ? acrissColumn() : categoriesColumn(),
			providersColumn(),
			carModelColumn(),
			doorsColumn(),
			seatsColumn(),
			transmissionColumn(),
			airConditionColumn(),
			ownerColumn(),
			actionsColumn(path)
		]}
		data={tableData}
	/>
	</>

}